import { z } from "zod";
import "../zod-runtime.js";
import { mapElementTypeSchema, sideSchema, slotSchema, workflowStatusSchema, } from "./enums.js";
import { pointSchema } from "./geometry.js";
export const assignmentStepSchema = z.object({
    order: z.number().int().min(1),
    title: z.string().min(1),
    detail: z.string().min(1),
    offsetSeconds: z.number().int().min(0).nullable().optional(),
});
export const assignmentSchema = z.object({
    slot: slotSchema,
    role: z.string().min(1),
    summary: z.string().min(1),
    timing: z.string().min(1),
    steps: z.array(assignmentStepSchema).min(1),
    route: z.array(pointSchema.extend({
        layerId: z.string().min(1).nullable().optional(),
    })),
    utilityIds: z.array(z.string().min(1)),
    utilityStepLinks: z
        .record(z.string(), z.number().int().min(1).nullable())
        .default({}),
    /** Team-Mitglieder (`Member.userId`), die diesen Slot in dieser Taktik spielen dürfen. */
    eligibleMemberIds: z.array(z.string().uuid()).default([]),
});
export const mapElementSchema = z.object({
    id: z.string().uuid(),
    type: mapElementTypeSchema,
    layer: z.number().int().min(0),
    label: z.string().nullable(),
    geometry: z.record(z.string(), z.unknown()),
    style: z.record(z.string(), z.unknown()).default({}),
    slot: slotSchema.nullable().default(null),
    stepOrder: z.number().int().min(1).nullable().default(null),
});
export const tacticSchema = z.object({
    id: z.string().min(1),
    mapId: z.string().min(1),
    side: sideSchema,
    status: workflowStatusSchema,
    category: z.string().min(1),
    name: z.string().min(1),
    objective: z.string().min(1),
    buyType: z.string().min(1),
    fallback: z.string().min(1),
    phases: z.array(z.string().min(1)).min(1).max(4),
    tags: z.array(z.string().min(1)).default([]),
    teamUtilityIds: z.array(z.string().min(1)),
    assignments: z.array(assignmentSchema).length(5),
    elements: z.array(mapElementSchema).default([]),
    source: z.record(z.string(), z.unknown()).nullable(),
    version: z.number().int().positive().default(1),
    approvedAt: z.string().datetime().nullable().optional(),
});
